import { useState, useRef, useEffect } from 'react';
import styles from './Intro.module.css';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LanguageContext } from '../../context/LanguageContext';
import { detectLanguage } from '../../utils/languages';
import Loader from '../../components/spinner/Loader';
import Cookies from 'js-cookie';
import { SLIDES } from "../../utils/helpers/intro/data"

export default function Intro() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const initial = Number(searchParams.get('chapter')) || 0;
  const token = Cookies.get('auth_token');
  const preferedLanguage = Cookies.get('preferedLanguage');

  const [current, setCurrent] = useState(initial);
  const [animState, setAnimState] = useState('idle');
  const [displayed, setDisplayed] = useState(initial);
  const isAnimating = useRef(false);
  const [language, setLanguage] = useState(null);

  const SUPPORTED_LANGS = process.env.REACT_APP_LANGUAGES.split(",").map(s => s.trim());
  const prefLang = SUPPORTED_LANGS.includes(preferedLanguage) ? preferedLanguage : detectLanguage();

  useEffect(() => {
    const hasSeenOnboarding = sessionStorage.getItem('hasSeenOnboarding');

    if (hasSeenOnboarding || token) {
      navigate('/', { replace: true });
    }
  }, [navigate, token]);

  useEffect(() => {
    setLanguage(prefLang);
  }, [prefLang]);

  const goTo = (next, direction) => {
    if (isAnimating.current || next === current) return;
    isAnimating.current = true;

    setAnimState(direction === 'next' ? 'exit_left' : 'exit_right');

    setTimeout(() => {
      setDisplayed(next);
      setAnimState(direction === 'next' ? 'enter_right' : 'enter_left');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setAnimState('idle');
          setCurrent(next);
          isAnimating.current = false;

          setSearchParams({ chapter: next }, { replace: true });
        });
      });
    }, 320);
  };

  const handleNext = () => {
    sessionStorage.setItem('hasSeenOnboarding', 'true');
    if (current < SLIDES.length - 1) goTo(current + 1, 'next');
  };

  const handlePrev = () => {
    if (current > 0) goTo(current - 1, 'prev');
  };

  const SlideComponent = SLIDES[displayed].component;
  const accentColor = SLIDES[current].color;

  if (!language) return <Loader />

  return (
    <LanguageContext.Consumer>
      {({ data }) => {
        const t = (key) => data?.[key]?.[language];
        return (
          <div className={styles.container}>
            <div className={styles.bubble} />
            <div className={styles.bubble} />
            <div className={styles.bubble} />

            <div className={styles.dots}>
              {SLIDES.map((_, i) => (
                <button
                  key={i}
                  className={`${styles.dot} ${i === current ? styles.dotActive : ''}`}
                  style={i === current ? { background: accentColor, width: 24 } : {}}
                  onClick={() => goTo(i, i > current ? 'next' : 'prev')}
                />
              ))}
            </div>

            <div className={styles.cardWrapper}>
              <div className={`${styles.card} ${styles[animState]}`}>
                <SlideComponent
                  handleNext={handleNext}
                  handlePrev={handlePrev}
                  current={current}
                  total={SLIDES.length}
                  t={t}
                />
              </div>
            </div>
          </div>
        );
      }}
    </LanguageContext.Consumer>
  );
}